var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStrap = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "animated_strap",
    viewBox: "0 0 320.09 257.05",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "animated_strap-u-layer-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "animated_strap-s-polygon2",
    points: "156.76,257.05 156.76,257.05 156.76,219.49 156.76,219.5 156.76,219.49 156.76,219.5 156.76,219.5 156.76,219.5 156.76,219.5 156.76,219.5 156.76,219.49 156.76,219.49 156.76,219.5 156.76,219.49 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05 156.76,257.05",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStrap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/strap.92dc5e53.svg";
export { ForwardRef as ReactComponent };